_collow.components.FeatureCarousel = class FeatureCarousel extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  amountOfFeatures;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;
    this.amountOfFeatures = elements.items.childNodes.length;

    this.listen(elements.prev, "click", this.onButtonClick.bind(this, -1));
    this.listen(elements.next, "click", this.onButtonClick.bind(this, 1));
  }

  onButtonClick(value) {
    let newPosition = +this.elements.items.dataset.featurePosition + value;
    if (newPosition < 0) newPosition = this.amountOfFeatures - 1;
    if (newPosition >= this.amountOfFeatures) newPosition = 0;
    this.elements.items.dataset.featurePosition = newPosition;
  }
};
